import React, {useEffect, useState, useRef} from 'react';
import {Tooltip} from "@mui/material";
import {jwtDecode} from "jwt-decode";
import LoaderCustomFixed from "../../ConfirmationModal/LoaderCustomFixed";
import {IoMdClose} from "react-icons/io";
import {IoLogOutOutline} from "react-icons/io5";
import {useNavigate} from "react-router-dom";
import "./AccountSettingsPopup.css"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExchangeAlt} from "@fortawesome/free-solid-svg-icons";
const AccountSettingsPopup = ({onClose, style}) => {
    const [roleId, setRoleId] = useState(null);
    const [email, setEmail] = useState(null);
    const [name, setName] = useState(null);
    const [surname, setSurname] = useState(null);
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const popupRef = useRef(null);
    const navigate = useNavigate();

    const switchUserToken = (userId) => {
        let currentUserToken = localStorage.getItem('jwtToken');
        let targetUserTokenKey = '';
        let targetUserToken = '';

        for (let i = 1; localStorage.getItem(`${i}_jwtToken`); i++) {
            let token = localStorage.getItem(`${i}_jwtToken`);
            try {
                let decoded = jwtDecode(token);
                if (decoded.UserId === userId) {
                    targetUserTokenKey = `${i}_jwtToken`;
                    targetUserToken = token;
                    break;
                }
            } catch (error) {

            }
        }

        if (targetUserTokenKey) {
            localStorage.setItem('jwtToken', targetUserToken);
            localStorage.setItem(targetUserTokenKey, currentUserToken);
            navigate("/dashboard/home")
            onClose();
            setSelectedUser(users.find(user => user.id === userId));
        }
    };


    useEffect(() => {
        const token = localStorage.getItem('jwtToken');
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setRoleId(decoded.role);
                setEmail(decoded.email_address);
                setName(decoded.FirstName);
                setSurname(decoded.LastName);
            } catch (error) {
            }
        }
    }, []);

    const handleLogout = () => {
        // Remove all items that contain 'jwtToken' in their name
        for (let i = localStorage.length - 1; i >= 0; i--) {
            const key = localStorage.key(i);
            if (key && key.includes("jwtToken")) {
                localStorage.removeItem(key);
            }
        }
        navigate("/");
    };

    useEffect(() => {
        const tokens = [];
        let i = 1;

        while (localStorage.getItem(`${i}_jwtToken`)) {
            tokens.push(localStorage.getItem(`${i}_jwtToken`));
            i++;
        }

        const loadedUsers = tokens.map(token => {
            try {
                const decoded = jwtDecode(token);
                return {
                    id: decoded.UserId,
                    email: decoded.email_address,
                    name: decoded.FirstName,
                    surname: decoded.LastName,
                    role: decoded.role
                };
            } catch (error) {
                console.error("Failed to decode JWT", error);
                return null;
            }
        }).filter(Boolean); // Filter out any null decoded tokens

        setUsers(loadedUsers);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClose]);

    const rolesInGeorgian = {
        'HEADOFAGENCY': "სააგენტოს უფროსი",
        'DEPUTYHEADOFAGENCY': "უფროსის მოადგილე",
        'HEADOFDEPARTMENT': "სამმართველოს უფროსი",
        'EXPERT': "სპეციალისტი"
    };

    return (
        <div className="header-popup-container" style={style} ref={popupRef}>
            <Tooltip title={"დახურვა"}>
                <div className="upload-single-close-icon-inspection-tooltip">
                    <IoMdClose className="header-popup-close-icon-inspection" onClick={onClose}/>
                </div>
            </Tooltip>
            {!users.length ? (
                <div style={{marginTop: "70%"}}>
                    <LoaderCustomFixed/>
                </div>
            ) : (
                <div>
                    <div className="header-popup-content">

                        <div className="user-info">
                            <div className="email-text">{email}</div>
                            <div className="name-initials">{name.charAt(0)}</div>
                            <div className="name-text">{name + ' ' + surname} </div>
                            <div className="role-text">({rolesInGeorgian[roleId]})</div>
                        </div>

                        <div className="user-option-container">
                            <ul className="user-option-list">
                                <li
                                    style={{
                                        textAlign: 'center',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                    className="user-option-item-title"
                                >
                                    ანგარიშის შეცვლა
                                    <FontAwesomeIcon icon={faExchangeAlt} style={{marginLeft: '15'}}/>
                                </li>
                                {users.map(user => (
                                    <li key={user.id}
                                        className="user-option-item"
                                        onClick={() => switchUserToken(user.id)}
                                        style={selectedUser?.id === user.id ? {backgroundColor: "#eef"} : {}}
                                    >
                                        <div className="user-option-initials">{user.name.charAt(0)}</div>
                                        {`${user.name} ${user.surname} (${user.email})`}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <button className="leave-button" onClick={handleLogout}>
                            <IoLogOutOutline/> გასვლა
                        </button>

                    </div>
                </div>
            )}
        </div>
    );
};

export default AccountSettingsPopup;
